export type Browser = 'chrome' | 'firefox' | 'safari' | 'opera' | 'edge';
export function inferBrowser(): Browser | null {
  const userAgent = navigator.userAgent;

  switch (true) {
    case !!userAgent.match(/chrome|chromium|crios/i): {
      return 'chrome';
    }
    case !!userAgent.match(/firefox|fxios/i): {
      return 'firefox';
    }
    case !!userAgent.match(/safari/i): {
      return 'safari';
    }
    case !!userAgent.match(/opr\//i): {
      return 'opera';
    }
    case !!userAgent.match(/edg/i): {
      return 'edge';
    }
    default: {
      return null;
    }
  }
}
